function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { default as MUITabs } from "@mui/material/Tabs";
const FRef = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/React.createElement(MUITabs, _extends({}, props, {
    ref: ref
  }));
});
export const Tabs = _ref => {
  let {
    classes,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(FRef, _extends({}, props, {
    sx: theme => ({
      "& .MuiTab-root": {
        padding: theme.spacing(2, 3),
        fontFamily: 'Poppins,"Helvetica Neue",Arial,sans-serif'
      },
      "& .MuiTabScrollButton-root": {
        paddingLeft: theme.spacing(0.5),
        paddingRight: theme.spacing(0.5)
      },
      "& .MuiTabs-indicator": {
        height: "4px",
        backgroundColor: theme.palette.text.primary
      }
    })
  }));
};
export default Tabs;